import 'javascripts/all_pages.js'
import 'javascripts/all_theme_styles.js'
import 'javascripts/nav_auto_scroll.js'
import {videoModal, jqTextCopy,scrollSync} from 'javascripts/general_scripts';
import {initGoogleCharts} from 'javascripts/utils/googleCharts';

jqTextCopy();
videoModal();
window.scrollSync = scrollSync; // used later by js when page data is refreshed
scrollSync();

const productIds = localStorage.productIds.split(',');

// for single chart display
let chartData = [{
    id: 'market_share',
    colors: 'yellow'
}]

productIds.forEach(p => {
    chartData.push({ id: `co_size_reviewers_${p}`, colors: 'default', pieHole: 0, fontSize: 14 });
    chartData.push({ id: `market_share_${p}`, colors: 'yellow' });
    // chartData.push({ id: `co_size_visitors_${p}`, colors: 'default'});
});

initGoogleCharts(chartData, 'pie');

// if the executive summary is expanded, show the cta button
$(document).on('click', '.collapsible', function() {
    if ($(this).find('.executive-cta').length) {
        $('.executive-cta').removeClass('d-none');
    }
});